import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          {/* <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button> */}
 <div className="flex items-center justify-between h-32">
          {/* Logo and Company Name Container */}
          <div className="flex items-center">
            {/* Logo */}
            <div className="flex-shrink-0">
              <img
              src={process.env.PUBLIC_URL+`/img/logo.png`}
                alt="Company Logo"
                className="h-32 w-64"
              />
            </div>
            {/* Company Name */}
            <div className="ml-3">
              <a className="navbar-brand page-scroll" href="#page-top">
              Swasthya Saathi
              </a>
            </div>
          </div>          
        </div> 
        </div>

        <div
          className=" navbar"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            {/* <li>
              <a href="#features" className="page-scroll">
                Features
              </a>
            </li> */}
            <li>
              <a href="#about" className="page-scroll">
                About
              </a>
            </li>
            {/* <li>
              <a href="#services" className="page-scroll">
                Services
              </a>
            </li> */}
            <li>
              <a href="#team" className="page-scroll">
                Team
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
